export default __webpack_public_path__ + "media/images/home/slide_hiruobi_2026_sm-48693a3cd23177360b4d385b37e6395f.jpg";